// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"da7bf776","879":"27f98cfd"}[chunkId] + ".chunk.js";
};